<!--  -->
<template>
    <div class="school">
        <div class="sync_jiaoyan">
            <div class="title">同步教研</div>
        </div>
        <div class="sync_chengzhang">
            <div class="course" v-if="courseList.length > 0">
                <div class="course_item" v-for="(item, index) in courseList" :key="index" @click="goCourse(item.id)">
                    <img :src="imgurl + item.cover" alt :onerror="$store.state.course.defaultCourseCover[index % 5]" />
                    <div class="course_name wes">{{ item.name }}</div>
                    <span class="course_time">上课时间：{{ item.timeScope }}</span>
                    <div class="course_time">主讲老师：{{ item.teacherName }}</div>
                </div>
            </div>
            <el-empty description="暂无课程" v-else></el-empty>
            <div class="more" @click="gocurriculumPublic" v-if="courseTotal > 12">更多</div>
        </div>
        <!-- <Login2 v-if="showLogin" :courseId='courseId'></Login2> -->
        <Login3 v-if="showLogin" @getUserinfo="getUserinfo"></Login3>
    </div>
</template>
<script>
export default {
    data() {
        return {
            imgurl: 'https://yun.cnuen.net/api/fu/front/upload/download?identifier=',
            syncCourseList: [],
            courseList: [],
            date: new Date(),
            currentDay: new Date().getFullYear() + '-' + String(new Date().getMonth() + 1).padStart(2, '0') + '-' +
                String(new Date().getDate()).padStart(2, '0'),
            courseObj: {},
            courseStatur: {
                unstart: "未开始",
                start: "上课中",
                end: "已下课"
            },
            courseId: null,
            showLogin: false,
            courseTotal:0
        }
    },
    methods: {
        getList() {
            let data = {
                page: 1,
                limit: 12,
                // projectId: 266
                projectId: 390
            }
            Api.Home.GetCloudCourse(data)
                .then(res => {
                    console.log('课程:', res);
                    this.courseList = res.data.records.filter(item => {
                        return item.id != 2469 && item.id != 2467 && item.id != 2789 && item.id != 2788
                    });
                })
                .catch(err => {
                    console.log('err:', err)
                })
        },
        prevMonth() {
            let currentDate = this.date;
            let currentMonth = currentDate.getMonth();
            this.date = new Date(currentDate.getFullYear(), currentMonth - 1, 1);
            this.getCourse()
        },
        nextMonth() {
            let currentDate = this.date;
            let currentMonth = currentDate.getMonth();
            this.date = new Date(currentDate.getFullYear(), currentMonth + 1, 1);
            this.getCourse()
        },
        //  Api.Home.getNews(params)
        getCourse() {
            // 获取当前时间
            let currentDate = this.date;
            // 获取年份
            let year = currentDate.getFullYear();
            // 获取月份（注意月份从0开始，所以需要加1）
            let month = currentDate.getMonth() + 1;
            // 格式化年份和月份
            let formattedDate = `${year}-${month.toString().padStart(2, '0')}`;
            let data = {
                month: formattedDate,
                projectId: 266
            };
            Api.Home.GetTimetable(data)
                .then(res => {
                    console.log('课程表:', res);
                    this.courseObj = res.data;
                    console.log(res.data['2023-08-04'])
                })
                .catch(err => {
                    console.log('获取课程表失败:', err)
                })
        },
        onDateChange(date) {
            console.log('当前选择的日期是:', date);
            this.currentDay = date;
            this.getCourseDetailByDay(date)
        },
        // 获取课程表某一天的数据
        getCourseDetailByDay(day) {
            let data = {
                day,
                projectId: 266
            }
            Api.Home.GetCloudCourseByDay(data)
                .then(res => {
                    console.log('获取课程表某一天的数据', res);
                    this.syncCourseList = res.data
                })
                .catch(err => {
                    console.log(err)
                })
        },
        goCourse(id) {
            this.courseId = id;
            // this.showLogin = true;
            // this.$store.commit('isDisplayLogin', true);
            window.open(
                `https://jm.cnuen.net/login?un=18131405634&pd=Syyq123456@&origin=jm&courseId=${this.courseId}&projectId=266&goPath=course&keyCode=d63becec70f41c0ae20bca40e81f81dc&captchaCode=rgdzf`
                //  `http://localhost:8081/login?un=${this.pwdForm.username}&pd=${this.pwdForm.password}&origin=jm&courseId=${this.courseId}&goPath=course&keyCode=d63becec70f41c0ae20bca40e81f81dc&captchaCode=rgdzf`
            );
        },
        gocurriculumPublic() {
            this.$router.push({
                path: 'curriculumPublic',
                query: {
                    markType: 3,
                    'breadNumber': 2,
                }
            })

        },
        //课程列表请求
        async getCourselist() {
            let data = {
                markId: 3,
                page: 1,
                limit: 8,
                orderType: 0,
                name: ''
            }
            let resData = await Api.Curriculum.getCourselist(data);
            console.log('同步教研推荐:', resData);
            this.courseList = resData.data.records;
            this.courseTotal = resData.data.total
        },
    },
    mounted() {
        // this.getList();
        this.getCourselist()
        this.getCourse()
    },
};
</script>
<style lang='less' scoped>
@import url('./less/school.less');
</style>